import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import xIcon from 'src/assets/images/icon/icon-xImg.svg'


export interface TermsModalProps {
  isOpen: boolean
  onClose: () => void
  termsUrl: string | null
}


const TermsModal = ({ isOpen, onClose, termsUrl }: TermsModalProps) => {
  useEffect(() => {
    if (!isOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [isOpen])

  if (!isOpen) return null

  return createPortal(
    <FullScreenWrap data-lenis-prevent-wheel data-lenis-prevent-touch>
      <CloseButton type="button" onClick={onClose} aria-label="닫기" />
      <IframeWrap>
        <iframe src={termsUrl ?? ''} title="약관 보기" />
      </IframeWrap>
    </FullScreenWrap>,
    document.body,
  )
}

export default TermsModal

const FullScreenWrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const CloseButton = styled.button`
  position: absolute;
  width: 24px;
  height: 24px;
  right: 16px;
  top: 16px;
  z-index: 1;
  cursor: pointer;
  background: url(${xIcon}) no-repeat center/contain;
  border: none;
`

const IframeWrap = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
`